import { axiosInstance } from "./axios-instance";

export const getAllCategories = (header) => {
  const data = axiosInstance
    .get(
      `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/trans/service/list?page=1&limit=20&sort=name&sortType=desc`,
      {
        headers: {
          Authorization: header,
          "Content-Type": "application/json",
        },
        data: {},
      }
    )
    .catch((errors) => {
      console.log(errors);
      return { data: undefined };
    });
  return data;
};

export const getAllResources = async (header, resourcesIds, serviceId) => {
  const data = await axiosInstance
    .get(
      `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/trans/service/resource/list?page=1&limit=20&sort=name&sortType=desc&resourcesIds=${resourcesIds}&serviceId=${serviceId}`,
      {
        headers: {
          Authorization: header,
          "Content-Type": "application/json",
        },
        data: {},
      }
    )
    .then((data) => {
      return data;
    })
    .catch((errors) => {
      console.log(errors);
      return { data: undefined };
    });

  return data;
};

export const getAvailabilitySpecialist = (
  header,
  serviceId,
  resourceId,
  year,
  month
) => {
  const data = axiosInstance
    .get(
      `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/trans/resource/availability?year=${year}&serviceId=${serviceId}&month=${month}&resourceId=${resourceId}`,
      {
        headers: {
          Authorization: header,
          "Content-Type": "application/json",
        },
        data: {},
      }
    )
    .catch((errors) => {
      console.log(errors);
      return { data: undefined };
    });
  return data;
};

// TODO: temporal change
export const postAssignAppointment = async (appointmentData, header) => {
  try {
    const response = await axiosInstance.post(
      `${process.env.URL_NUTRICIONSALUDABLE_USER}/pesosaludable/common/api/v2.0/appointment/add`,
      appointmentData,
      {
        headers: {
          Authorization:   "Bearer " + header,
          "Content-Type": "application/json",
          'Apikey': process.env.APIKEY_SALUD,
        },
      }
    );
    return response.data;
  } catch (errors) {
    console.log(errors);
    return { datas: undefined };
  }
};
// export const postAssignAppointment = (
//   customer,
//   dateTime,
//   resource,
//   service,
//   header
// ) => {
//   const datas = axiosInstance
//     .post(
//       `${process.env.URL_NUTRICIONSALUDABLE_USER}/pesosaludable/common/api/v2.0/appointment/add`,
//       {
//         customer,
//         dateTime,
//         resource,
//         service,
//       },
//       {
//         headers: {
//           Authorization: header,
//           "Content-Type": "application/json",
//         },
//       }
//     )
//     .catch((errors) => {
//       console.log(errors);
//       return { datas: undefined };
//     });
//   return datas;
// };

export const updateDate = (appointmentId, header, body) => {
  const data = axiosInstance
    .post(
      `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/trans/appointment/update/${appointmentId}`,
      body,
      {
        headers: {
          Authorization: header,
          "Content-Type": "application/json",
        },
      }
    )
    .catch((errors) => {
      console.log(errors);
      return { datas: undefined };
    });
  return data;
};


// TODO: temporal change
export const getProfessionals = async (service, place, token) => {
  try {
    const response = await axiosInstance.get(
      `${process.env.URL_NUTRICIONSALUDABLE_USER}/pesosaludable/common/api/v2.0/professionals/getAll?service=${service}&place=${place}`,
      {
        headers: {
          Authorization:
            "Bearer " +
            token,
            'Apikey': process.env.APIKEY_SALUD,
            Accept: "application/json"
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
    return undefined;
  }
};

// TODO: test
export const getPlaces = async (service, token) => {
   return axiosInstance.get(
     `${process.env.URL_NUTRICIONSALUDABLE_USER}/pesosaludable/common/api/v2.0/places/getAll?service=${service}`,
     {
       headers: {
        Authorization:
          "Bearer " +
          token,
          'Apikey': process.env.APIKEY_SALUD,
          Accept: "application/json"
      }
       
     }
   );
 };

export const getDurations = async (token, service) => {
   let config = {
     method: "get",
     maxBodyLength: Infinity,
     url:
       process.env.URL_NUTRICIONSALUDABLE_USER + "/pesosaludable/common/api/v2.0/services/validateAccesService?serviceType=" +
       service,
     // TODO: use env vars
     headers: {
       Authorization:
         "Bearer " +
         token,
         'Apikey': process.env.APIKEY_SALUD,
     }
   };
   return axiosInstance.request(config);
 };

export const getFee = async (token, service) => {
  try {
    const response = await axiosInstance.get(
      `${process.env.URL_NUTRICIONSALUDABLE_USER}/pesosaludable/common/api/v2.0/appointment/fee?servicAppTimifyId=${service}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error("Error:", error);
    return undefined;
  }
};
// TODO: end of test

export const getAvailableDate = async (place, professional, service, date, token) => {
  try {
    const response = await axiosInstance.get(
      `${process.env.URL_NUTRICIONSALUDABLE_USER}/pesosaludable/common/api/v2.0/professionals/availability/month?place=${place}&professional=${professional}&service=${service}&referenceDate=${date}`,
      //  `${process.env.URL_NUTRICIONSALUDABLE_USER}/pesosaludable/common/api/v2.0/professionals/checkAvailabilityByMonthAndProfessional?professional=${professional}&service=${service}&referenceDate=${date}`,
      {
        headers: {
          Authorization:
            "Bearer " +
            token,
            'Apikey': process.env.APIKEY_SALUD,
            Accept: "application/json"
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
    return undefined;
  }
};
